module.exports = __webpack_public_path__ + "img/opengraph-thumbnail.5ca0d9ce.jpeg";